import customError from 'custom-error';

export const Unauthorized = customError('Unauthorized');
export const BadRequest = customError('BadRequest');
export const UnknownError = customError('UnknownError');
export const NetworkError = customError('NetworkError');
export const ServiceUnavailableError = customError('ServiceUnavailableError');
